import { gql } from "@apollo/client";

export const CONTACT_LISTING_AGENT_MUTATION = gql`
  mutation contact_sale_listing_agent($input: ContactSaleListingAgentInput!) {
    contact_sale_listing_agent(input: $input) {
      ... on ContactAgentResult {
        recipients {
          name
        }
      }
      ... on ContactAgentErrors {
        errors {
          type
          messages
        }
      }
    }
  }
`;
